
import React from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Card } from "@/components/ui/card";
import { Brain, ChartBar, Lightbulb, Target, BarChart3 } from "lucide-react";
import { useGame } from '../../contexts/GameContext';
import DashboardTab from './tabs/DashboardTab';
import GuidanceTab from './tabs/GuidanceTab';
import ObjectivesTab from './tabs/ObjectivesTab';
import SkillsAcquisitionTab from './tabs/SkillsAcquisitionTab';
import StatisticsTab from './tabs/StatisticsTab';

const CareerDashboardTabs: React.FC = () => {
  return (
    <Tabs defaultValue="dashboard" className="w-full">
      <TabsList className="grid grid-cols-5 mb-4 w-full">
        <TabsTrigger value="dashboard" className="flex items-center">
          <ChartBar className="h-4 w-4 mr-2" /> Dashboard
        </TabsTrigger>
        <TabsTrigger value="statistics" className="flex items-center">
          <BarChart3 className="h-4 w-4 mr-2" /> Statistics
        </TabsTrigger>
        <TabsTrigger value="guidance" className="flex items-center">
          <Lightbulb className="h-4 w-4 mr-2" /> Guidance
        </TabsTrigger>
        <TabsTrigger value="objectives" className="flex items-center">
          <Target className="h-4 w-4 mr-2" /> Objectives
        </TabsTrigger>
        <TabsTrigger value="skills" className="flex items-center">
          <Brain className="h-4 w-4 mr-2" /> Skills
        </TabsTrigger>
      </TabsList>

      {/* Dashboard Tab Content */}
      <TabsContent value="dashboard" className="space-y-6">
        <DashboardTab />
      </TabsContent>

      {/* Statistics Tab Content */}
      <TabsContent value="statistics" className="space-y-6">
        <StatisticsTab />
      </TabsContent>

      {/* Guidance Tab Content */}
      <TabsContent value="guidance" className="space-y-6">
        <GuidanceTab />
      </TabsContent>

      {/* Objectives Tab Content */}
      <TabsContent value="objectives" className="space-y-6">
        <ObjectivesTab />
      </TabsContent>

      {/* Skills Tab Content */}
      <TabsContent value="skills" className="space-y-6">
        <SkillsAcquisitionTab />
      </TabsContent>
    </Tabs>
  );
};

export default CareerDashboardTabs;
